import { Model } from 'dva'
import { TTSProvider } from '../types'
import { TtsService } from '../../../Service'
import { IsObject } from '../../../Utils/helpers'
import { FailureHandler } from 'Utils/ApiHelper'

const TTSProviders: Model = {
  namespace: 'ttsProviders',
  state: {
    list: [],
  },
  effects: {
    *list(
      { useCache = true, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let ttsProviders = yield select((state: any) => state.ttsProviders.list)
        if (!(ttsProviders.length > 0 && useCache)) {
          ttsProviders = yield call(TtsService.ttsList, {})
          yield put({ type: 'modifyList', payload: ttsProviders })
        }
        onSuccess(ttsProviders)
      } catch (err: any) {
        FailureHandler('Error fetching TTS Providers', err, onFailure)
      }
      setLoading(false)
    },
    *retrieve(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        let ttsProvider = yield select((state: any) =>
          state.ttsProviders.list.find((ttsProvider: TTSProvider) => ttsProvider.id === id)
        )
        if (!ttsProvider) {
          ttsProvider = yield call(TtsService.ttsRetrieve, { id: id })
        }
        yield put({ type: 'modifyList', payload: ttsProvider })
        onSuccess(ttsProvider)
      } catch (err) {
        FailureHandler('Could not find the TTS Provider!', err, onFailure)
      }
      setLoading(false)
    },
    *create(
      { data = {}, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TtsService.ttsCreate, { requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error adding a TTS Provider!', err, onFailure)
      }
      setLoading(false)
    },
    *partialUpdate(
      { id, data, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put }
    ) {
      setLoading(true)
      try {
        const response = yield call(TtsService.ttsPartialUpdate, { id: id, requestBody: data })
        yield put({ type: 'modifyList', payload: response })
        onSuccess(response)
      } catch (err) {
        FailureHandler('Error editing a TTS Provider!', err, onFailure)
      }
      setLoading(false)
    },
    *destroy(
      { id, setLoading = () => {}, onSuccess = () => {}, onFailure = () => {} },
      { call, put, select }
    ) {
      setLoading(true)
      try {
        yield call(TtsService.ttsDestroy, { id: id })
        yield put({ type: 'modifyList', payload: id })
        onSuccess()
      } catch (err) {
        FailureHandler('Error deleting a ttsProvider', err, onFailure)
      }
      setLoading(false)
    },
  },
  reducers: {
    modifyList(state, action) {
      // clone the list
      let list = [...state.list]
      if (IsObject(action.payload)) {
        // if the payload is an object, it's a single object, so add it to the list
        list = list.filter((l: TTSProvider) => l.id !== action.payload.id)
        list.push(action.payload)
      } else if (Array.isArray(action.payload)) {
        // if the payload is an array, it's a list of objects, so add them to the list
        list = list
          .filter((l: TTSProvider) => !action.payload.map((p: TTSProvider) => p.id).includes(l.id))
          .concat(action.payload)
      } else if (Number.isInteger(action.payload)) {
        // if the payload is an integer, it's an id sent in delete operations, so remove it from the list
        list = list.filter((l: TTSProvider) => l.id !== action.payload)
      }
      return {
        ...state,
        list: list,
      }
    },
    resetTTSProviders(state, action) {
      return {
        ...state,
        list: [],
      }
    },
  },
}

export default TTSProviders
